import React from "react";
import backgroundImage from "../../../assets/willalwaysloveu-main-section.jpeg";
import { Link } from "react-router-dom";
import "./hero.css";

const Hero = () => {
  return (
    <div
      className="hero-container"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        filter: "grayscale(20%)",
      }}
    >
      <h1 className="main-text">Create an online memorial to celebrate their life</h1>
      <p className="second-para">Virtual memorial service for families across the United States</p>
      <p className="third-para">
        Honor a loved one with a beautiful memorial website—share photos, videos,
        tributes, and stories in one lasting online remembrance page for family and friends.
      </p>
      <button className="mBtn">
        <Link to="/creatememorial" className="hero-create">
          Create a Memorial
        </Link>
      </button>
    </div>
  );
};

export default Hero;
